module.exports = __webpack_public_path__ + "img/swords.06d9e485.svg";